/**
 * Reguła wygaszenia przy prawej krawędzi poziomo przewijanego rzędu.
 *
 * Siedzi tu, a nie w komponencie, bo to jedyna część tej sprawy, którą da się sprawdzić
 * testem jednostkowym: jsdom nie liczy układu i ma tam zawsze `scrollWidth === 0`.
 * Czy gradient naprawdę się pokazuje, sprawdza bramka na WebKicie
 * (scripts/check-pasek-obszarow.mjs).
 */
export interface StanPrzewijania {
  scrollLeft: number;
  clientWidth: number;
  scrollWidth: number;
}

/**
 * Lewa krawędź. Osobna funkcja, a nie `scrollLeft > 0`, bo przeglądarki potrafią zostawić
 * ułamek piksela po dotknięciu, a gradient zapalony na samym początku listy mówiłby, że
 * coś jest po lewej, kiedy nic tam nie ma.
 */
export function czyMoznaPrzewinacWLewo(m: Pick<StanPrzewijania, 'scrollLeft'>): boolean {
  return m.scrollLeft > 1;
}

export function czyMoznaPrzewinacWPrawo(m: {
  scrollLeft: number;
  clientWidth: number;
  scrollWidth: number;
}): boolean {
  // Tolerancja 1 px: przy ułamkowych szerokościach (a te są normą po skalowaniu czcionki)
  // scrollLeft + clientWidth potrafi zatrzymać się o pół piksela przed scrollWidth i
  // gradient zostawałby zapalony na zawsze w stanie „już na końcu".
  return m.scrollLeft + m.clientWidth < m.scrollWidth - 1;
}
